import React, { useContext, useEffect, useState } from 'react';
import { IProps } from './types';
import * as S from './styles';
import { Context } from "routes/private/Editor/Context";
import { RedoIcon } from '@assets/icons/redoIcon';
import Tooltip from '@components/Tooltip';

const RedoCommandOption : React.FC<IProps> = () => {
  let { onUndoRedo, dataRedo } = useContext(Context);

  return (
    <S.Root>
      <Tooltip tip={"Redo"}>
      <S.ButtonContainer active={dataRedo.length>0} onClick={()=>{if (dataRedo.length>0) onUndoRedo("redo");}}>
          <RedoIcon opacity={dataRedo.length>0 ? 1 : 0.3}/>
        </S.ButtonContainer>
      </Tooltip>
    </S.Root>
  );
}

export default RedoCommandOption;